<template>
  <div style="width: 100%; height: 100%" id="qrcode" ref="qrcode"></div>
</template>
<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import OSS from "ali-oss";
export default {
  data() {
    return {
      qrcode: "",
      // OSS阿里云上传配置信息
      //   keysArr: {
      //     AccessKeySecret: "u8MInb3yMvqjL3zEVELLCcwBIiFU0x",
      //     AccessKeyId: "LTAI4G3RxALQgKhQj9f7GiNY",
      //     UrlHeader: "https://img2.meite.com/",
      //     Expiration: "",
      //     SecurityToken: "",
      //   },
      //   uploadfile: {},
    };
  },
  props: {
    // id: {
    //   type: String,
    //   required: true,
    // },
    codeUrl: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "80",
    },
    height: {
      type: String,
      default: "80",
    },
    colorDark: {
      type: String,
      default: "#000000",
    },
    colorLight: {
      type: String,
      default: "#ffffff",
    },
  },
  watch: {
    codeUrl(newText) {
      this.createQrcode();
    },
  },
  created() {},
  mounted() {
    this.createQrcode();
  },
  methods: {
    // createPoster() {
    //   // 生成海报
    //   let dom = this.$refs["qrcode"];
    //   html2canvas(dom, {
    //     width: dom.clientWidth, // 生成图片的宽度
    //     height: dom.clientHeight, // 生成图片的高度
    //     scale: 9, //scale 将其调大可以解决低分辨率设备下生成的图片模糊问题
    //     useCORS: true, // 是否允许跨域 如果不行在img标签增加 crossOrigin="Anonymous" 属性
    //   }).then((canvas) => {
    //     // 生成一个base64的图片路径
    //     let dataURL = canvas.toDataURL("image/png");
    //     let myName = this.codeUrl + ".jpg";
    //     console.log("111", dataURL);
    //     this.downloadFile(dataURL, myName);
    //   });
    // },

    // dataURLtoBlob(dataurl) {
    //   const arr = dataurl.split(",");
    //   const mime = arr[0].match(/:(.*?);/)[1];
    //   const bstr = atob(arr[1]);
    //   let n = bstr.length;
    //   const u8arr = new Uint8Array(n);
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n);
    //   }
    //   return new Blob([u8arr], { type: mime });
    // },
    // downloadFile(url, name) {
    //   const a = document.createElement("a");
    //   a.setAttribute("href", url);
    //   a.setAttribute("download", name);
    //   a.setAttribute("target", "_blank");
    //   const clickEvent = document.createEvent("MouseEvents");
    //   clickEvent.initEvent("click", true, true);
    //   a.dispatchEvent(clickEvent);
    // },
    //下载到本地
    // download(record) {
    //   html2canvas(this.$refs[this.id], {
    //     scale: 5,
    //   }).then((canvas) => {
    //     const base64 = canvas.toDataURL("image/png");
    //     const myBlob = this.dataURLtoBlob(base64);
    //     const myUrl = URL.createObjectURL(myBlob);
    //     console.log("myUrl---", myUrl);
    //     const myName = this.title + ".jpg";
    //     this.downloadFile(myUrl, myName);
    //   });
    // },
    // 有新的二维码地址了，先把之前的清除掉
    createQrcode() {
      if (this.qrcode) {
        this.$refs["qrcode"].innerHTML = "";
      }
      this.qrcode = new QRCode(this.$refs["qrcode"], {
        text: this.codeUrl,
        width: this.width,
        height: this.height,
        colorDark: this.colorDark,
        colorLight: this.colorLight,
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.experienceItem {
  text-align: center;
  margin-right: 20px;
  border: 1px solid #dcdfe6;
  .itemBox {
    padding: 20px;
    .itemTitle {
      margin-bottom: 10px;
    }
    .itemImg {
      margin-bottom: 10px;
    }
    .itemAccounts {
      margin-bottom: 10px;
    }
    .itemPassword {
    }

    .itemTitle3 {
      padding: 10px 0;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .itemBtn {
    padding: 0px 20px 20px 20px;
    .btn {
      border: 1px solid #ddd;
      line-height: 30px;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }
}
.my-canvas {
  position: fixed;
  right: 0;
  bottom: 0;
  background-color: red;
}
.downloadBox {
  position: fixed;
  left: -100%;
  bottom: 0;
}
</style>
